import { useState } from 'react'
import useInputDebounce from 'hooks/useInputDebounce'
import { SearchBarProps } from './types'

export default function useSearchInput( { search, setSearch, debounceDelay }: SearchBarProps ) {
	const [ inputVal, setInputVal ] = useState( search )

	useInputDebounce( inputVal, debounceDelay ?? 300, ( debouncedInputValue ) => {
		setSearch( debouncedInputValue )
	} )

	return { inputVal, setInputVal }
}
